export default __webpack_public_path__ + "static/media/logonew.f7edfb15.png";